<template>
  <woot-button
    variant="smooth"
    class="topic--add"
    icon="add"
    size="tiny"
    @click="addTopic"
  >
    {{ $t('CONTACT_PANEL.TOPICS.CONVERSATION.ADD_BUTTON') }}
  </woot-button>
</template>

<script>
export default {
  methods: {
    addTopic() {
      this.$emit('add');
    },
  },
};
</script>

<style lang="scss" scoped>
.topic--add {
  margin-bottom: var(--space-micro);
  margin-right: var(--space-micro);
}
</style>

